export default "<span *ngIf=\"message\" class=\"snack-bar\">\n  {{message.message}}\n</span>\n"